/** "lea@…": the design shows invitees by the start of their address only. */
export function maskEmail(email: string): string {
  return `${email.split('@')[0]}@…`;
}
